var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "additionals-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("Доборные элементы")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: { src: _vm.urlForStatic("/img/additionals_tip_1.png") }
        })
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: { src: _vm.urlForStatic("/img/additionals_tip_2.png") }
        })
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v(
        "Чтобы добавить на сцену доборный элемент, поставьте в рабочей области "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("две точки")]),
      _vm._v(
        " так так, чтобы ограниченный данными точками отрезок образовывал\n        "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("сторону")]),
      _vm._v(" будущего доборного элемента, как показано на рисунке.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("После построения отрезка - в рабочей области появится "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("фигура")]),
      _vm._v(" - плоскость доборного элемента и две направляющие линий. "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("Перемещая точки")
      ]),
      _vm._v(" фигуры можно корректировать геометрию доборного элемента.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }